// Presentation labels for the Skill contract's own closed vocabularies (§28). The labels never
// decide anything: every VALUE comes from the server, and an unrecognized token is printed
// verbatim rather than dropped, so a server vocabulary addition cannot render a blank cell.
export const SKILL_DOMAIN_LABELS = {
  "microsoft entra": "Microsoft Entra",
  "windows networking": "Windows Networking",
  "fortigate": "FortiGate",
  "endpoint security": "Endpoint Security",
};

export const SKILL_SUBDOMAIN_LABELS = {
  "conditional access": "Conditional Access",
  "exchange online": "Exchange Online",
};

export function skillDomainLabel(token) {
  if (typeof token !== "string" || !token) return token;
  return SKILL_DOMAIN_LABELS[token] || SKILL_SUBDOMAIN_LABELS[token] || token;
}
